import logoPlaceholderSrc from "../images/icon.png"

/** Use on `<img>` for remote logos: swap to bundled Hive Index placeholder if the URL fails. */
export function setLogoImgFallbackOnError(event) {
  const el = event.currentTarget
  el.src = logoPlaceholderSrc
  el.onerror = null
  el.alt = ""
}
